export const DEFAULT_MEETING_NOTIFICATION_CADENCE = [1440, 60];

export const MEETING_REMINDER_OPTIONS = [
  { value: 10080, label: '1 week before' },
  { value: 4320, label: '3 days before' },
  { value: 2880, label: '2 days before' },
  { value: 1440, label: '1 day before' },
  { value: 720, label: '12 hours before' },
  { value: 360, label: '6 hours before' },
  { value: 180, label: '3 hours before' },
  { value: 120, label: '2 hours before' },
  { value: 60, label: '1 hour before' },
  { value: 30, label: '30 minutes before' },
  { value: 15, label: '15 minutes before' },
];

export const formatReminderCadence = (minutes = DEFAULT_MEETING_NOTIFICATION_CADENCE) => (minutes || []).join(', ');

export const parseReminderCadence = (value) => Array.from(new Set(
  String(value || '')
    .split(',')
    .map((part) => parseInt(part.trim(), 10))
    .filter((num) => Number.isFinite(num) && num > 0)
)).sort((a, b) => b - a);

export const normalizeReminderCadence = (minutes = DEFAULT_MEETING_NOTIFICATION_CADENCE) => Array.from(new Set(
  (Array.isArray(minutes) ? minutes : [])
    .map((value) => parseInt(value, 10))
    .filter((num) => Number.isFinite(num) && num > 0)
)).sort((a, b) => b - a);

export const describeReminderMinutes = (minutes) => {
  const option = MEETING_REMINDER_OPTIONS.find((item) => item.value === minutes);
  if (option) return option.label;

  if (minutes % 10080 === 0) {
    const weeks = minutes / 10080;
    return `${weeks} week${weeks === 1 ? '' : 's'} before`;
  }

  if (minutes % 1440 === 0) {
    const days = minutes / 1440;
    return `${days} day${days === 1 ? '' : 's'} before`;
  }

  if (minutes % 60 === 0) {
    const hours = minutes / 60;
    return `${hours} hour${hours === 1 ? '' : 's'} before`;
  }

  return `${minutes} minutes before`;
};
